import tooltipDirective from '@/directives/tooltip'
import observeVisibilityDirective from '@/directives/observeVisibility'
import globalComponents from '@/components/globals'
import { installActivityLog } from '@/common/activityLog'

export const VUE3_ROOT_ID = 'vue3-app'

// App-level configuration shared by both mount paths (per-page createVueApp
// and the router shell).
export default function configureApp(app) {
  app.directive('tooltip', tooltipDirective)
  app.directive('observe-visibility', observeVisibilityDirective)
  app.use(globalComponents)
  installActivityLog()
  return app
}
